import React, { useRef, useEffect } from "react";
import lottie from "lottie-web";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import workforceLottie from "./assets/workforce.json";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: "85vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "auto",
    },
    workforce: {
        justifyContent: "center",
        textAlign: "center",
    },
    lottieImage: {
        margin: "auto",
        width: theme.spacing(50),
    },
}));

export default function Welcome() {
    const classes = useStyles();
    const image = useRef(null);

    useEffect(() => {
        lottie.loadAnimation({
            container: image.current,
            render: "svg",
            loop: true,
            autoplay: true,
            animationData: workforceLottie,
        });
    }, []);

    return (
        <Box className={classes.root}>
            <Box className={classes.workforce}>
                <Box className={classes.lottieImage} ref={image} />
                <Typography variant="h4" className={classes.typographyPrimary}>
                    USE THE WORKFORCE MENU
                </Typography>
                <Typography>
                    to upload, edit and analyze your workforce - across multiple companies and all bias-free.
                </Typography>
                <Typography>• coming soon •</Typography>
            </Box>
        </Box>
    );
}
